<div class="row">
  <!-- Filed Starts -->
  <div class="col-12 form-group">
    <h3 style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
      Instant Payment Card
    </h3>
  </div>

  <div class="col-12">
    <div class="form-group" *ngFor="let card of cards;let i = index;" style="max-width: 430px;">
      <div class="card card_bg">
        <div class="card-body">
          <div class="align-item-center d-flex justify-content-between">
            <label class="name-label">{{card?.name}}</label>
            <figure>
              <img style="width:69px;"
              [src]="getCardBrandImage(card)"
            *ngIf="['mastercard', 'discover', 'jcb', 'visa', 'american express', 'unionpay', 'diners club', 'diners', 'amex'].includes(card.brand.toLowerCase()); else no_card">
              <ng-template #no_card>
                <img style="width:69px;"
                [src]="'assets/img/svg/card-type/no_card.svg'"
                >
            </ng-template>
            </figure>
          </div>
          <!-- custom Radio card -->
          <div class="form-input border-0" style="cursor: pointer;min-width: 300px; padding: 0px 0px !important;">
            <label for="r1" class="d-flex mb-0 align-items-center justify-content-between">
              <p class="mb-4 name-label">
                XXXX<span class="ms-3 me-3">-</span>
                XXXX<span class="ms-3 me-3">-</span>
                XXXX<span class="ms-3 me-3">-</span>
                <span>{{ card.last4 }}</span>
              </p>
            </label>
            <label class="d-flex mb-0 mt-2 align-items-center justify-content-between">
              <p class="mb-0">
                <span class="exp-name">Expiry</span> <br> <span
                  *ngIf="card.exp_month<10">0</span>{{card.exp_month}}/{{card.exp_year.toString().substr(-2)}}
              </p>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 pt-2 px-0 mb-4">
      <u>
        <button class="btn-def" (click)="fileChangeEvent($event)">
          {{ cards.length == 1 ? "Update Card" : "Add New Card" }}
        </button>
      </u>
    </div>
  </div>
</div>